<script setup>
import { computed } from "vue"

const apiBase = useApiBase()
const apiUrl = apiBase ? `${apiBase}/api/hero/` : "/api/hero/"
const { data } = await useFetch(apiUrl, { key: "home-hero" })

const resolveImageUrl = (url) => {
  if (!url) return ""
  if (/^https?:\/\//i.test(url)) return url
  if (url.startsWith("/media/")) return url
  return url
}

const sectionData = computed(() => data.value?.section || null)
const partners = computed(() => (data.value?.partners?.length ? data.value.partners : []))
const badges = computed(() => (data.value?.badges?.length ? data.value.badges : []))

</script>

<template>
  <section v-if="sectionData" class="section-hero">
      <div
        class="hero__container__left"
        style="translate: none; rotate: none; scale: none; opacity: 1; transform: translate(0px, 0%);"
      >
        <div class="hero__container__left__text">
          <h1 class="hero-title">
            {{ sectionData.title_prefix }}
            <span class="span-accent">{{ sectionData.title_suffix }}</span>
          </h1>
          <div class="text-regular-18" v-html="sectionData.subtitle"></div>
        </div>
        <div class="hero__container__left__bottom">
          <div data-openform class="button-classic">
            <p class="paragraph">{{ sectionData.button_label }}</p>
          </div>
          <div class="logo__container__partners">
            <div v-for="partner in partners" :key="partner.id" class="icon-44r">
              <img
                v-if="partner.image_url"
                :src="resolveImageUrl(partner.image_url)"
                loading="lazy"
                :alt="partner.alt"
                class="image-01"
              >
            </div>
          </div>
          <div class="hero__container__left__bottom__info">
            <p class="text-regular-18 color-text-dark">{{ sectionData.bottom_title }}</p>
            <p class="text-regular-16">{{ sectionData.bottom_subtitle }}</p>
          </div>
        </div>
      </div>
      <div
        class="hero__container__right"
        style="translate: none; rotate: none; scale: none; opacity: 1; transform: translate(0px, 0px);"
      >
        <div class="hero-deco-blur"></div>
        <div class="hero-deco-img">
          <img
            v-if="sectionData.deco_image_url"
            :src="resolveImageUrl(sectionData.deco_image_url)"
            loading="lazy"
            alt=""
            class="image-cover"
          >
        </div>
        <div class="hero__animation__wrapper">
          <div v-for="n in 2" :key="n" class="hero__animation__container">
            <div v-for="badge in badges" :key="badge.id" class="info-el">
              <p class="text-regular-16 color-text-dark">{{ badge.title }}</p>
              <div class="icon-24">
                <img v-if="badge.icon_url" :src="resolveImageUrl(badge.icon_url)" alt="" class="image-cover">
              </div>
            </div>
          </div>
        </div>
      </div>
    <div id="home" class="scroll-anchor hero-section"></div>
  </section>
</template>

<style lang="scss" scoped>
@use '/assets/scss/sections/_hero.scss';
</style>
